import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ThongBaoThanhVien } from 'src/app/shared/ThongBaoThanhVien.model';
import { BaseService } from './Base.service';
@Injectable({
    providedIn: 'root'
})
export class ThongBaoThanhVienService extends BaseService {

    list: ThongBaoThanhVien[] | undefined;
    list001: ThongBaoThanhVien[] | undefined;
    formData!: ThongBaoThanhVien;    

    displayColumns001: string[] = ['STT', 'Name', 'Active', 'Save'];  

    constructor(public httpClient: HttpClient) {
        super(httpClient);
        this.controller = "ThongBaoThanhVien";
    }
}

